import store from '../../stores/index.js';
/**
 * 公共设置权限控制
 * 使用方法：$showMenuOrBtn({menu_code: 1, isBtn: true})  menu_id：菜单对应id  isBtn: 控制相应模块按钮权限
 * @param {*} val 
 * @returns 
 */
const showMenuOrBtn = (val) => {
    // console.log(store.state.config.allAuthList)
    const mergedArray = Object.values(store.state.config.allAuthList).reduce((acc, cur) => acc.concat(cur), []);
  
    let showMenuArr0 = mergedArray.map(item => {
        if (item.permission == 0) return item.menu_code;
    });
    let showMenuArr1 = mergedArray.map(item => {
        if (item.permission == 1) return item.menu_code;
    });
    let showMenuArr2 = mergedArray.map(item => {
        if (item.permission == 2) return item.menu_code;
    });

    if (showMenuArr0.includes(val.menu_code)) {
        return false;
    } else if (showMenuArr1.includes(val.menu_code)) {
        if (val.isBtn) return false;
        return true;
    } else if (showMenuArr2.includes(val.menu_code)) {
        return true;
    }
    // return true;
}

export default showMenuOrBtn;



// WEBPACK FOOTER //
// ./src/util/toolClass/showMenuOrBtn.js